<template>
    <div>
        <div class="row">
            <div class="col-md-6 d-md-flex align-items-baseline">
                <h1 class="mb-0">Clinic Hours</h1>
            </div>
            <div class="col-md-6 pb-3 input-group d-flex justify-content-end">
                <div v-if="!isEditing">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        @click="editClicked"
                    >
                        Edit
                    </button>
                </div>
                <div v-else>
                    <button
                        type="button"
                        class="btn btn-primary mr-2"
                        @click="saveClicked"
                    >
                        Save Changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-secondary"
                        @click="cancelClicked"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
        <b-card footer-class="p-0" class="rounded-lg side-tab">
            <div class="tab-body row">
                <LoaderList v-if="isLoading" class="w-100" />
                <div v-else class="table-responsive table-clinic-hour">
                    <table class="table list">
                        <thead>
                            <tr>
                                <th>Day:</th>
                                <th>Regular Hours:</th>
                                <th>After Hours:</th>
                            </tr>
                        </thead>
                        <tbody v-if="clinicHours && clinicHours.length">
                            <template
                                v-for="(clinicHour, index) in clinicHours"
                            >
                                <template v-if="isEditing">
                                    <tr
                                        :key="'row-' + index"
                                        v-if="
                                            clinicHoursUpdate[index].status &&
                                            clinicHoursUpdate[index].status !=
                                                '0'
                                        "
                                    >
                                        <td>
                                            <div
                                                class="green-toggle custom-control custom-switch"
                                            >
                                                <input
                                                    :id="'day' + index"
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    v-model="
                                                        clinicHoursUpdate[index]
                                                            .status
                                                    "
                                                    :value="
                                                        clinicHoursUpdate[index]
                                                            .status
                                                    "
                                                    true-value="1"
                                                    false-value="0"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="'day' + index"
                                                    >{{
                                                        getDayName(
                                                            clinicHour.day
                                                        )
                                                    }}</label
                                                >
                                            </div>
                                        </td>
                                        <td>
                                            <div
                                                class="d-flex align-items-center"
                                            >
                                                <timepicker
                                                    v-validate="'required'"
                                                    :name="'start_time' + index"
                                                    class="form-control"
                                                    placeholder="Start"
                                                    v-model="
                                                        clinicHoursUpdate[index]
                                                            .start_time
                                                    "
                                                    @input="
                                                        startTimeUpdated(index)
                                                    "
                                                    :class="{
                                                        'border-danger':
                                                            errors.has(
                                                                'start_time' +
                                                                    index
                                                            )
                                                    }"
                                                />
                                                <span class="mx-2">to</span>
                                                <timepicker
                                                    v-validate="'required'"
                                                    :name="'end_time' + index"
                                                    class="form-control"
                                                    placeholder="End"
                                                    v-model="
                                                        clinicHoursUpdate[index]
                                                            .end_time
                                                    "
                                                    @input="
                                                        endTimeUpdated(index)
                                                    "
                                                    :class="{
                                                        'border-danger':
                                                            errors.has(
                                                                'end_time' +
                                                                    index
                                                            )
                                                    }"
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div
                                                class="d-flex align-items-center"
                                            >
                                                <timepicker
                                                    :name="
                                                        'after_start_time' +
                                                        index
                                                    "
                                                    class="form-control"
                                                    placeholder="Start"
                                                    v-model="
                                                        clinicHoursUpdate[index]
                                                            .start_after_time
                                                    "
                                                    @input="
                                                        afterStartTimeUpdated(
                                                            index
                                                        )
                                                    "
                                                    :class="{
                                                        'border-danger':
                                                            errors.has(
                                                                'after_start_time' +
                                                                    index
                                                            )
                                                    }"
                                                />
                                                <span class="mx-2">to</span>
                                                <timepicker
                                                    :name="
                                                        'after_end_time' + index
                                                    "
                                                    class="form-control"
                                                    placeholder="End"
                                                    v-model="
                                                        clinicHoursUpdate[index]
                                                            .end_after_time
                                                    "
                                                    @input="
                                                        afterEndTimeUpdated(
                                                            index
                                                        )
                                                    "
                                                    :class="{
                                                        'border-danger':
                                                            errors.has(
                                                                'after_end_time' +
                                                                    index
                                                            )
                                                    }"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr :key="'row-' + index" v-else>
                                        <td>
                                            <div
                                                class="green-toggle custom-control custom-switch"
                                            >
                                                <input
                                                    :id="'day' + index"
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    v-model="
                                                        clinicHoursUpdate[index]
                                                            .status
                                                    "
                                                    :value="
                                                        clinicHoursUpdate[index]
                                                            .status
                                                    "
                                                    true-value="1"
                                                    false-value="0"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="'day' + index"
                                                    >{{
                                                        getDayName(
                                                            clinicHour.day
                                                        )
                                                    }}</label
                                                >
                                            </div>
                                        </td>
                                        <td
                                            colspan="2"
                                            class="close-clinic-hour"
                                        >
                                            <span>Closed</span>
                                        </td>
                                    </tr>
                                </template>

                                <template v-else>
                                    <tr
                                        :key="'row-' + index"
                                        v-if="clinicHour.status"
                                    >
                                        <td>
                                            {{ getDayName(clinicHour.day) }}
                                        </td>
                                        <td>
                                            {{
                                                `${clinicHour.start_time} to ${clinicHour.end_time}`
                                            }}
                                        </td>
                                        <td>
                                            {{
                                                clinicHour.start_after_time
                                                    ? `${clinicHour.start_after_time} to ${clinicHour.end_after_time}`
                                                    : "-"
                                            }}
                                        </td>
                                    </tr>
                                    <tr :key="'row-' + index" v-else>
                                        <td>
                                            {{ getDayName(clinicHour.day) }}
                                        </td>
                                        <td colspan="2">Closed</td>
                                    </tr>
                                </template>
                            </template>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td :colspan="9">
                                    <i>No records available</i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import LoaderList from "@/components/elements/loader-list";
import clinicHourService from "@/services/setting/clinic-hour";
import moment from "moment";

export default {
    components: {
        Timepicker: () => import("@/module/commons/time-picker.vue"),
        LoaderList
    },
    data() {
        return {
            isLoading: true,
            isEditing: false,
            clinicHours: [],
            clinicHoursUpdate: [],
            hasError: false
        };
    },
    watch: {},
    computed: {},
    created() {
        this.getClinicHours();
    },
    methods: {
        async getClinicHours() {
            this.isLoading = true;

            const response = await clinicHourService.getClinicHours();

            if (response && response.length) {
                this.clinicHours = response;

                // NOTE: To cater when time is 12AM, API return null for time display
                this.clinicHours = this.clinicHours.map(clinicHour => {
                    clinicHour["start_time"] = this.getTime(clinicHour.start);
                    clinicHour["end_time"] = this.getTime(clinicHour.end);

                    if (
                        clinicHour.start_after_hour !== null &&
                        clinicHour.end_after_hour !== null
                    ) {
                        clinicHour["start_after_time"] = this.getTime(
                            clinicHour.start_after_hour
                        );
                        clinicHour["end_after_time"] = this.getTime(
                            clinicHour.end_after_hour
                        );
                    }

                    return clinicHour;
                });
            }

            this.isLoading = false;
        },
        async updateClinicHours(clinicHours) {
            if (this.isLoading) return;
            this.isLoading = true;

            const response = await clinicHourService.updateClinicHours(
                clinicHours
            );

            if (response && response.message && response.message.code === 200) {
                this.isEditing = false;
                await this.getClinicHours();
            }

            this.isLoading = false;
        },
        getDayName(dayNumber) {
            return moment().isoWeekday(dayNumber).format("dddd");
        },
        editClicked() {
            if (this.isLoading || this.isEditing) return;
            this.clinicHoursUpdate = JSON.parse(
                JSON.stringify(this.clinicHours)
            );
            this.isEditing = true;
        },
        cancelClicked() {
            if (this.isLoading) return;
            this.isEditing = false;
        },
        async saveClicked() {
            if (this.hasError) {
                return;
            }

            if (this.validateAfterHoursField()) {
                return;
            }

            let valid = await this.$validator.validateAll();

            if (!valid) {
                return;
            }

            const clinicHours = this.clinicHoursUpdate.map(clinicHour => {
                return {
                    id: clinicHour.id,
                    start: clinicHour.start,
                    end: clinicHour.end,
                    start_after_hour: clinicHour.start_after_hour,
                    end_after_hour: clinicHour.end_after_hour,
                    status:
                        typeof clinicHour.status === "string"
                            ? Number(clinicHour.status)
                            : clinicHour.status
                };
            });

            await this.updateClinicHours(clinicHours);
        },
        getMinutes(dateObject) {
            if (!dateObject || !dateObject.c) {
                return null;
            }

            // Extract hours and minutes
            const hours = dateObject.c.hour;
            const minutes = dateObject.c.minute;

            // Convert hours and minutes to total minutes
            const totalMinutes = hours * 60 + minutes;
            return totalMinutes;
        },
        getTime(totalMinutes) {
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;
            const specificDate = moment().set({
                hour: hours,
                minute: minutes,
                second: 0
            });

            const formattedTime = specificDate.format("hh:mm A");

            return formattedTime;
        },
        startTimeUpdated(index) {
            const startTime = this.getMinutes(
                this.clinicHoursUpdate[index].start_time
            );

            this.clinicHoursUpdate[index].start = startTime;

            if (startTime > this.clinicHoursUpdate[index].end) {
                this.$validator.errors.add({
                    field: "end_time" + index,
                    msg: "Error: End time must be greater than start time"
                });
                this.hasError = true;
            } else if (this.clinicHoursUpdate[index].end_time) {
                this.$validator.errors.remove("end_time" + index);
                this.hasError = false;
            }
        },
        endTimeUpdated(index) {
            const endTime = this.getMinutes(
                this.clinicHoursUpdate[index].end_time
            );

            this.clinicHoursUpdate[index].end = endTime;

            if (endTime < this.clinicHoursUpdate[index].start) {
                this.$validator.errors.add({
                    field: "start_time" + index,
                    msg: "Error: Start time must be lesser than end time"
                });
                this.hasError = true;
            } else if (this.clinicHoursUpdate[index].start_time) {
                this.$validator.errors.remove("start_time" + index);
                this.hasError = false;
            }
        },
        afterStartTimeUpdated(index) {
            if (!this.clinicHoursUpdate[index].start_after_time) {
                this.clinicHoursUpdate[index].start_after_hour = null;
                return;
            }

            const startTime = this.getMinutes(
                this.clinicHoursUpdate[index].start_after_time
            );

            this.clinicHoursUpdate[index].start_after_hour = startTime;
        },
        afterEndTimeUpdated(index) {
            if (!this.clinicHoursUpdate[index].end_after_time) {
                this.clinicHoursUpdate[index].end_after_hour = null;
                return;
            }

            const endTime = this.getMinutes(
                this.clinicHoursUpdate[index].end_after_time
            );

            this.clinicHoursUpdate[index].end_after_hour = endTime;
        },
        validateAfterHoursField() {
            let hasError = false;

            this.clinicHoursUpdate.forEach((clinicHour, index) => {
                if (clinicHour.status && clinicHour.status != 0) {
                    if (
                        clinicHour.start_after_hour == null &&
                        clinicHour.end_after_hour != null
                    ) {
                        hasError = true;
                        this.$validator.errors.add({
                            field: "after_start_time" + index,
                            msg: "Error: Start hour must be field in"
                        });
                    } else {
                        this.$validator.errors.remove(
                            "after_start_time" + index
                        );
                    }

                    if (
                        clinicHour.start_after_hour != null &&
                        clinicHour.end_after_hour == null
                    ) {
                        hasError = true;
                        this.$validator.errors.add({
                            field: "after_end_time" + index,
                            msg: "Error: Start hour must be field in"
                        });
                    } else {
                        this.$validator.errors.remove("after_end_time" + index);
                    }
                }
            });

            return hasError;
        }
    }
};
</script>

<style lang="scss" scoped>
.row {
    margin-right: -15px !important;
    margin-left: -15px !important;
}
.table-clinic-hour {
    .table {
        max-width: 1000px;
    }

    .table thead th {
        border: none;
    }

    .table tbody tr:last-child {
        td {
            border: none;
        }
    }

    .table.list td {
        padding: 18px 8px;
        white-space: nowrap;
    }

    .table.list td.close-clinic-hour {
        padding: 16px 8px 17.41px;

        span {
            padding: 8px;
            background-color: #edeff2;
            border-radius: 6px;
            color: #b2b9c0;
            display: block;
        }
    }
}
.row {
    margin: auto;
}
</style>
